import * as React from 'react';

interface IErrorBoundaryState {
    error: Error | null;
    children?: React.ReactNode;
}

export class ErrorBoundary extends React.PureComponent<any, IErrorBoundaryState> {
    public static getDerivedStateFromError(error: Error): { error: Error } {
        return { error };
    }

    constructor(props: any) {
        super(props);
        this.state = {
            error: null,
        };
    }

    public componentDidCatch(error: Error | null): void {
        this.setState({ error });
    }

    public render() {
        const { children } = this.props;
        const { error } = this.state;
        if (error) {
            return (
                <div className="d-flex flex-column justify-content-center align-items-center pt-5">
                    <div className="alert alert-outline-warning" role="alert">
                        An unknown error has occured. Please contact
                        {' '}
                        <a href="mailto:sgmarkets@sgcib.com" className="alert-link">
                            sgmarkets@sgcib.com
                        </a>
                    </div>
                    <button type="button" className="btn btn-primary my-5" onClick={this.reload}>
                        Reload
                    </button>
                    {this.renderErrorDetails()}
                </div>
            );
        }

        return children;
    }

    private renderErrorDetails() {
        const { error } = this.state;
        return  (
            <div>
                <div>
                    {error?.name}
                </div>
                <div>
                    {error?.message}
                </div>
                <pre>
                    {JSON.stringify(error?.stack).replace(/\\n/g, '\n')}
                </pre>
            </div>
        );
    }

    private reload = (): void => {
        this.setState({
            error: null,
        });
    };
}
